import script from "./CartPriceItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./CartPriceItem.vue?vue&type=script&setup=true&lang=ts"

import "./CartPriceItem.vue?vue&type=style&index=0&id=27ce7dce&lang=css"

const __exports__ = script;

export default __exports__